import React, { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const YOUTUBE_ID = "-Z7XYoY38Js";

function loadYouTubeAPI() {
  if (window.YT && window.YT.Player) return Promise.resolve();
  if (window._ytApiPromise) return window._ytApiPromise;
  window._ytApiPromise = new Promise((resolve) => {
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    document.head.appendChild(tag);
    window.onYouTubeIframeAPIReady = () => resolve();
  });
  return window._ytApiPromise;
}

export default function WatchPage() {
  const { code } = useParams();
  const holder = useRef(null);
  const sentPct = useRef(0);
  const [name, setName] = useState("");

  useEffect(() => {
    document.title = "Before your call — BrandChilly";
    axios.get(`${API}/watch/${code}`).then(({ data }) => setName(data.first_name)).catch(() => {});

    let player, timer, cancelled = false;
    const report = (force = false) => {
      try {
        const dur = player.getDuration();
        const cur = player.getCurrentTime();
        if (!dur) return;
        const pct = Math.min(100, Math.round((cur / dur) * 100));
        if (force || pct >= sentPct.current + 5) {
          sentPct.current = Math.max(sentPct.current, pct);
          axios.post(`${API}/watch/${code}/progress`, { percent: pct, seconds: Math.round(cur) }).catch(() => {});
        }
      } catch { /* player not ready */ }
    };
    loadYouTubeAPI().then(() => {
      if (cancelled || !holder.current) return;
      player = new window.YT.Player(holder.current, {
        videoId: YOUTUBE_ID,
        playerVars: { rel: 0, modestbranding: 1, playsinline: 1 },
        events: {
          onStateChange: (e) => {
            if (e.data === window.YT.PlayerState.ENDED) {
              sentPct.current = 100;
              axios.post(`${API}/watch/${code}/progress`, { percent: 100, seconds: Math.round(player.getDuration()) }).catch(() => {});
            }
            if (e.data === window.YT.PlayerState.PAUSED) report(true);
          },
        },
      });
      timer = setInterval(() => report(), 5000);
    });
    return () => { cancelled = true; clearInterval(timer); try { player && player.destroy(); } catch { /* noop */ } };
  }, [code]);

  return (
    <div className="coaches-page" style={{ minHeight: "100vh", background: "var(--c-bg)" }}>
      <header className="border-b border-white/5">
        <div className="max-w-5xl mx-auto px-5 h-14 md:h-16 flex items-center">
          <Link to="/" data-testid="watch-logo"><img src="/assets/logo.png" alt="BrandChilly" className="h-8 md:h-10 w-auto" /></Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-5 py-10 md:py-16">
        <div className="c-eyebrow mb-3">Before your strategy call</div>
        <h1 className="text-3xl md:text-5xl leading-[1.05] text-white" data-testid="watch-heading">
          {name ? `${name}, watch this` : "Watch this"} <span className="c-red">5-minute video</span> before we talk.
        </h1>
        <p className="mt-4 c-muted text-sm md:text-base max-w-2xl">
          It covers how we think about growth, so we can skip the basics on the call and go straight to your business.
        </p>
        <div className="mt-8 border border-white/10" style={{ aspectRatio: "16 / 9", background: "#000" }} data-testid="watch-player">
          <div ref={holder} className="w-full h-full" />
        </div>
        <p className="mt-6 text-sm c-muted">— Saurabh Khaspuri, BrandChilly</p>
      </main>
    </div>
  );
}
